import React from 'react';
import { Toggle, Message } from '@getro/rombo';
import { Text } from 'rebass/styled-components';
import { Label } from '@rebass/forms/styled-components';
import toast from 'react-hot-toast';

import {
  useGetNetworkMovementPreferencesQuery,
  useUpdateNetworkMovementPreferenceMutation,
} from '../../../services/networkMovementPreferences';

const NetworkMovementsNotifications = () => {
  const { data, isLoading, isError } = useGetNetworkMovementPreferencesQuery();
  const [updatePreference] = useUpdateNetworkMovementPreferenceMutation();

  if (isLoading) {
    return null;
  }

  if (isError) {
    return (
      <Message type="warning" mt="56px">
        Unable to load network movement preferences.
      </Message>
    );
  }

  const preferences = data?.data
    ? [...data.data].sort((a, b) => (a.collectionName || '').localeCompare(b.collectionName || ''))
    : [];

  if (preferences.length === 0) {
    return null;
  }

  const handleToggle = (collectionId) => (e) => {
    const { checked } = e.target;
    updatePreference({ collectionId, enabled: checked })
      .unwrap()
      .catch(() => {
        toast('Failed to update preference. Please try again.', { icon: 'error', id: 'network-movement-pref' });
      });
  };

  return (
    <>
      <Text
        mt="56px"
        pb="8px"
        fontSize="12px"
        color="text.subtle"
        sx={{ borderBottom: 1, borderBottomColor: 'neutral.100', textTransform: 'uppercase', letterSpacing: '1px' }}
      >
        Network movements
      </Text>

      {preferences.map((pref) => (
        <React.Fragment key={pref.collectionId}>
          <Text mt="3" pt="1" pb="2" fontWeight="medium" color="text.dark">
            {pref.collectionName} — Weekly report
          </Text>
          <Label justifyContent="space-between">
            <Text fontWeight="body" fontSize="1" color="text.main">
              Get a weekly email with new hires detected in {pref.collectionName}.
            </Text>
            <Toggle
              data-testid={`network-movements-toggle-${pref.collectionId}`}
              aria-label={`Toggle weekly movements report for ${pref.collectionName}`}
              size="large"
              value
              checked={pref.enabled}
              onChange={handleToggle(pref.collectionId)}
            />
          </Label>
        </React.Fragment>
      ))}
    </>
  );
};

export default NetworkMovementsNotifications;
